import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * Content Wrapper which can handle html and non html content.
 * @param props
 * @returns
 */
const CartNavbarItem = () => {
  const [bvdReactModuleId, setBvdReactModuleId] = useState('');
  useEffect(() => {
    setBvdReactModuleId('bv-cart-counter');
  }, []);

  return (
    <Box
      sx={{
        display: { xs: 'flex' },
        marginRight: { xs: 1, sm: 3 },
      }}
      id={bvdReactModuleId}
    ></Box>
  );
};

export default CartNavbarItem;
